export default "__VITE_ASSET__Y0dRw$4M__"